import NextChallengeBanner from 'components/NextChallengeBanner';
import { FC } from 'react';
import { INextChallengeBanner } from './@types';
import { logger } from '../../utils';
import { CType } from '../../models/Contentful/types';

const NextChallengeBannerBlade: FC<CType<INextChallengeBanner>> = props => {
  try {
    const { fields } = props;
    return <NextChallengeBanner {...fields} />;
  } catch (error) {
    logger.error(error);
    return null;
  }
};

export default NextChallengeBannerBlade;
